import React, { Component } from "react";
import ManagementTable from "../../../components/management/ManagementTable.js";
import Backend from "../../../utils/Backend"; // ✅ use Backend (FetchHelper + auth)

export default class NotificationHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      history: [],
      searchTerm: "",
      userTypeFilter: "All",
      sentByFilter: "All",
      startDate: "",
      endDate: "",
      isLoading: false,
    };

    this._debounceRef = null;
  }

  componentDidMount() {
    this._fetchHistory();
  }

  componentWillUnmount() {
    if (this._debounceRef) clearTimeout(this._debounceRef);
  }

  _fetchHistory = async () => {
    const { searchTerm, userTypeFilter, sentByFilter, startDate, endDate } = this.state;

    this.setState({ isLoading: true });

    try {
      const params = {
        search: searchTerm || "",
        userType: userTypeFilter || "All",
        sentBy: sentByFilter || "All",
        start: startDate || "",
        end: endDate || "",
      };

      const data = await Backend.getNotificationHistory(params);

      // ✅ FetchHelper sometimes returns {results: []} depending on your API style
      const list = Array.isArray(data) ? data : Array.isArray(data?.results) ? data.results : [];

      this.setState({ history: list, isLoading: false });
    } catch (e) {
      console.error("Failed to fetch notification history:", e);
      this.setState({ history: [], isLoading: false });
    }
  };

  _handleInputChange = (e) => {
    const { name, value } = e.target;

    this.setState({ [name]: value }, () => {
      // ✅ debounce (typing search)
      if (this._debounceRef) clearTimeout(this._debounceRef);
      this._debounceRef = setTimeout(() => {
        this._fetchHistory();
      }, 250);
    });
  };

  _getColumns = () => [
    {
      Header: () => <strong className="header__clr">TITLE</strong>,
      accessor: "title",
      Cell: (row) => <span className="text-dark-75 font-weight-bold">{row.value}</span>,
    },
    {
      Header: () => <strong className="header__clr">MESSAGE</strong>,
      accessor: "message",
      width: 300,
      Cell: (row) => (
        <span className="text-dark-50 small text-truncate d-block" style={{ maxWidth: "280px" }}>
          {row.value}
        </span>
      ),
    },
    {
      Header: () => <strong className="header__clr">USER TYPE</strong>,
      accessor: "recipients",
      Cell: (row) => <span className="label label-inline label-light-primary">{row.value}</span>,
    },
    {
      Header: () => <strong className="header__clr">TOTAL USERS</strong>,
      accessor: "count",
      Cell: (row) => <span className="font-weight-bold text-success">{row.value}</span>,
    },
    {
      Header: () => <strong className="header__clr">SENT BY</strong>,
      accessor: "sentBy",
    },
    {
      Header: () => <strong className="header__clr">SENT DATE</strong>,
      accessor: "date",
    },
    {
      Header: () => <strong className="header__clr">ACTIONS</strong>,
      sortable: false,
      width: 120,
      Cell: (row) => (
        <>
          <button
            className="btn btn-icon btn-sm btn-light-info mr-2"
            title="View Details"
            onClick={() => console.log("View campaign:", row?.original)}
          >
            <i className="la la-eye"></i>
          </button>
          <button
            className="btn btn-icon btn-sm btn-light-primary"
            title="Resend Notification"
            onClick={() => console.log("Resend campaign:", row?.original)}
          >
            <i className="la la-redo"></i>
          </button>
        </>
      ),
    },
  ];

  render() {
    return (
      <div className="container">
        <ManagementTable
          title="Notification History"
          columns={this._getColumns()}
          data={this.state.history} // ✅ already filtered by server
          isLoading={this.state.isLoading} // if your table supports it
          renderToolbar={() => (
            <div className="card-toolbar d-flex flex-wrap align-items-center">
              <div className="input-icon mr-4 mb-2 mb-md-0" style={{ width: "200px" }}>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search title/message..."
                  name="searchTerm"
                  value={this.state.searchTerm}
                  onChange={this._handleInputChange}
                />
                <span>
                  <i className="flaticon2-search-1 text-muted"></i>
                </span>
              </div>

              <div className="mr-4 mb-2 mb-md-0" style={{ width: "150px" }}>
                <select
                  className="form-control"
                  name="userTypeFilter"
                  value={this.state.userTypeFilter}
                  onChange={this._handleInputChange}
                >
                  <option value="All">All User Types</option>
                  <option value="Customers">Customers</option>
                  <option value="Drivers">Drivers</option>
                  <option value="Vendors">Vendors</option>
                </select>
              </div>

              <div className="mr-4 mb-2 mb-md-0" style={{ width: "130px" }}>
                <select
                  className="form-control"
                  name="sentByFilter"
                  value={this.state.sentByFilter}
                  onChange={this._handleInputChange}
                >
                  <option value="All">Sent By: All</option>
                  {/* NOTE: This will only work if your Django filter matches these strings */}
                  <option value="Admin">Admin</option>
                  <option value="Manager">Manager</option>
                </select>
              </div>

              <div className="d-flex align-items-center mb-2 mb-md-0">
                <input
                  type="date"
                  className="form-control form-control-sm mr-2"
                  name="startDate"
                  value={this.state.startDate}
                  onChange={this._handleInputChange}
                />
                <span className="mr-2 text-muted">-</span>
                <input
                  type="date"
                  className="form-control form-control-sm"
                  name="endDate"
                  value={this.state.endDate}
                  onChange={this._handleInputChange}
                />
              </div>
            </div>
          )}
        />
      </div>
    );
  }
}